import Vue from 'vue'
import Container from '@/components/Container'
import PageTitle from '@/components/PageTitle'

Vue.component('Container', Container)
Vue.component('PageTitle', PageTitle)
